module.exports = __webpack_public_path__ + "img/star.c94d7c52.png";